export function getConvertedProviderSearch(input: string): string {
    const trimmedInput = input.trim();

    const prefixPattern = /^(Doctor[:.,]?|doctor[:.,]?|Dr[:.,]?|dr[:.,]?)\s*/i;
    const result = trimmedInput.replace(prefixPattern, '');

    return result.trim();
}
